// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ApprovalOfCharges\ApiApprovalOfCharges.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { ApprovedCharge, ApprovedChargeData, ApprovedChargeOptions } from 'data/models/ApprovedCharge';
import { BillingSystem, BillingSystemData, BillingSystemOptions } from 'data/models/BillingSystem';
import { DispatchEvent, DispatchEventData, DispatchEventOptions } from 'data/models/DispatchEvent';
import { JobOrder, JobOrderData, JobOrderOptions } from 'data/models/JobOrder';

// ApprovalOfChargesData is the class that ApprovalOfCharges serializes to/from
export interface ApprovalOfChargesData {
    Id : number;
	
    BillingSystem : BillingSystemData | null;
    BillingSystemId : number;
    Charges : ApprovedChargeData[] | null;
    DispatchEvent : DispatchEventData | null;
    DispatchEventId : number;
    JobOrder : JobOrderData | null;
    JobOrderId : number;
	
    ApprovalDate : /* ISO8601 */ string;
    Guid : /* GUID */ string;
    Type : string | null;
}

// ApprovalOfChargesOptions is the class which may be passed to the ApprovalOfCharges constructor to define optional initial data values
export interface ApprovalOfChargesOptions {
    Id : number;
	
    BillingSystem? : BillingSystemOptions | null;
    BillingSystemId? : number;
    Charges? : ApprovedChargeOptions[] | null;
    DispatchEvent? : DispatchEventOptions | null;
    DispatchEventId? : number;
    JobOrder? : JobOrderOptions | null;
    JobOrderId? : number;
	
    ApprovalDate? : /* ISO8601 */ string;
    Guid? : /* GUID */ string;
    Type? : string | null;
}

export class ApprovalOfCharges {
    public Id : DataSignal<number>;
	
    public BillingSystem : DataSignal<BillingSystem | null>;
    public BillingSystemId : DataSignal<number>;
    public Charges : SDataArray<ApprovedCharge>;
    public DispatchEvent : DataSignal<DispatchEvent | null>;
    public DispatchEventId : DataSignal<number>;
    public JobOrder : DataSignal<JobOrder | null>;
    public JobOrderId : DataSignal<number>;
	
    public ApprovalDate : DataSignal<TZDate>;
    public Guid : DataSignal<string>;
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : ApprovalOfChargesOptions);
    constructor(data: ApprovalOfChargesOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.BillingSystem = S.value<BillingSystem | null>(null);
        this.BillingSystemId = jsonableObservable(S.value<number>(data && data.BillingSystemId !== undefined ? data.BillingSystemId : 0));
        this.Charges = SArray<ApprovedCharge>([]);
        this.DispatchEvent = S.value<DispatchEvent | null>(null);
        this.DispatchEventId = jsonableObservable(S.value<number>(data && data.DispatchEventId !== undefined ? data.DispatchEventId : 0));
        this.JobOrder = S.value<JobOrder | null>(null);
        this.JobOrderId = jsonableObservable(S.value<number>(data && data.JobOrderId !== undefined ? data.JobOrderId : 0));
	    
        this.ApprovalDate = jsonableObservable(S.value<TZDate>(data && data.ApprovalDate !== undefined ? new TZDate(data.ApprovalDate) : new TZDate(0), TZDate.eq));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : ApprovalOfCharges) {
        return obj.Id();
    }
    
    static dataKey(obj : ApprovalOfChargesOptions) {
        return obj.Id;
    }

    static update(obj : ApprovalOfCharges, data : ApprovalOfChargesOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BillingSystemId !== undefined) obj.BillingSystemId(data.BillingSystemId);
            if (data.DispatchEventId !== undefined) obj.DispatchEventId(data.DispatchEventId);
            if (data.JobOrderId !== undefined) obj.JobOrderId(data.JobOrderId);
	        
            if (data.ApprovalDate !== undefined) obj.ApprovalDate(new TZDate(data.ApprovalDate));
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ApprovalOfCharges.ts